import React, { useState, useEffect } from 'react';
import {
  Container,
  Paper,
  Typography,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Dialog,
  DialogTitle,
  DialogContent,
  Divider,
  Box,
} from '@mui/material';
import { PageIndices } from '../common/i-doc/i-doc.registry.ts';
import { DashboardLayout } from '../components/DashboardLayout';
import api from '../services/api';

interface Page {
  name: string;
  path: string;
}

const StaticContentPage: React.FC = () => {
  const [staticPages, setStaticPages] = useState<Page[]>([]);
  const [dynamicPages, setDynamicPages] = useState<Page[]>([]);
  const [selectedPage, setSelectedPage] = useState<string | null>(null);
  const [pageContent, setPageContent] = useState<string>('');
  const [isModalVisible, setIsModalVisible] = useState(false);

  useEffect(() => {
    api.get('/information')
      .then(response => {
        const { data } = response.data;
        if (data) {
          setStaticPages(data.static || []);
          setDynamicPages(data.dynamic || []);
        } else {
          console.error('API response is not in expected format:', response.data);
          setStaticPages([]);
          setDynamicPages([]);
        }
      })
      .catch(error => {
        console.error('Error fetching pages list:', error);
        setStaticPages([]);
        setDynamicPages([]);
      });
  }, []);

  const handlePageClick = (page: Page) => {
    setSelectedPage(page.name);
    api.get(page.path)
      .then(response => {
        setPageContent(response.data);
        setIsModalVisible(true);
      })
      .catch(error => {
        console.error(`Error fetching content for page ${page.name}:`, error);
      });
  };

  const handleModalClose = () => {
    setIsModalVisible(false);
    setSelectedPage(null);
    setPageContent('');
  };

  return (
    <DashboardLayout onChangePassword={() => {}}>
      <Container maxWidth="lg" data-i-doc={PageIndices.STATIC_CONTENT}>
        <Paper sx={{ mt: 3 }}>
          <Box sx={{ p: 2 }}>
            <Typography variant="h6">Статичні сторінки</Typography>
            <List>
              {staticPages.map(page => (
                <ListItem key={page.name} disablePadding>
                  <ListItemButton onClick={() => handlePageClick(page)}>
                    <ListItemText primary={page.name} />
                  </ListItemButton>
                </ListItem>
              ))}
            </List>
          </Box>

          <Divider />

          <Box sx={{ p: 2 }}>
            <Typography variant="h6">Інформація про метрики</Typography>
            <List>
              {dynamicPages.map(page => (
                <ListItem key={page.name} disablePadding>
                  <ListItemButton onClick={() => handlePageClick(page)}>
                    <ListItemText primary={page.name} />
                  </ListItemButton>
                </ListItem>
              ))}
            </List>
          </Box>

        </Paper>
      </Container>
      <Dialog
        open={isModalVisible}
        onClose={handleModalClose}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle>{selectedPage}</DialogTitle>
        <DialogContent dividers>
          <div dangerouslySetInnerHTML={{ __html: pageContent }} />
        </DialogContent>
      </Dialog>
    </DashboardLayout>
  );
};

export default StaticContentPage;
